import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { Textarea } from '../../../components/ModalInputs';
import ModalFooter from '../../../components/ModalFooter/ModalFooter';
import styles from './index.module.css'

export default function ModalComponent ({
    closeModal, 
    modalData, 
    setNewAccessData,
    newAccessData,
    saveChanges,
    setModalData
    }) {

    const [description, setDescription] = useState('');
    const handleSubmit = () => {
        saveChanges();
        closeModal();
        setDescription('');
        setModalData(null);
    }

    const handleClose = () => {
        setDescription('');
        closeModal();
        setModalData(null);
    }

    useEffect(() => {
        setDescription(modalData?.description);
    }, [modalData])

    const handleChange = (e) => {
        const {name, value} = e.target;
        setDescription(value);
        const modifyAccessData = JSON.parse(JSON.stringify(newAccessData));
        const modifyItem = modifyAccessData[0];
        modifyItem[name] = value;
        modifyAccessData[0] = modifyItem;
        setNewAccessData(modifyAccessData);
    }
    
  
  return (
      <Modal
        open={modalData}
        onClose={() => handleClose()}
        showCloseIcon={false}
        height={'auto'}
        center
        closeOnOverlayClick={true}
        closeOnEsc={true}
        classNames={{
            modal: styles.custom
        }}>
        <div className={styles.modalLocal}>
        <div className={styles.tabWrapper}>
          
        <Textarea 
            className={styles.textarea}
            name={'description'}
            value={description}
            label={'Описание'} 
            onChange={(e) => handleChange(e)} />
        </div>
        </div>
        <ModalFooter 
            handleSubmit={() => handleSubmit()}
            closeModal={handleClose} />

      </Modal>
  )
}
